import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que restablece el scroll al inicio (0, 0) de la ventana
 * cada vez que cambia la ruta o los parámetros de navegación.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Si la navegación incluye un hash (#), se permite el salto a dicho ancla
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }

    // De lo contrario, desplazar suavemente o instantáneamente al tope
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior,
    });
  }, [pathname, search]);

  return null;
};
